const lambda = require("./lambdaCall")

function subscribe(email, list = null, dob = null, listId = null, kibling = false) {
  const formData = JSON.stringify({
    email: email,
    list: list,
    dob: dob,
    environment:
      process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || "development",
    listId: listId,
    kibling: kibling
  })

  return lambda
    .lambdaCall({
      url: "klaviyo",
      method: "POST",
      body: formData,
    })
    .then((response) => {
      return Promise.all([response.status])
    })
    .then(([statusCode]) => {
      let status
      let message

      if (statusCode === 200) {
        status = "success"
        message = "newsletter.success_message"
      } else {
        status = "error"
        message = "newsletter.error_message"
      }

      return {
        status: status,
        message: message,
      }
    })
}

function getSignupFormId(version) {
  const activeEnv = process.env.GATSBY_ACTIVE_ENV || "us"
  const DESKTOP_FORM_ID =
    activeEnv === "us"
      ? "SiAiR5"
      : activeEnv === "uk"
      ? "RsarxM"
      : activeEnv === "eu"
      ? "TBGQLg"
      : "VHj9Mv"

  const MOBILE_FORM_ID =
    activeEnv === "us"
      ? "VmShKD"
      : activeEnv === "uk"
      ? "QZ7sVK"
      : activeEnv === "eu"
      ? "WcLxyy"
      : "WKuJ6z"

  if (version === "mobile") {
    return MOBILE_FORM_ID
  }

  return DESKTOP_FORM_ID
}

module.exports = {
  subscribe: subscribe,
  getSignupFormId: getSignupFormId
}
